/** 青山科技奖常见问题解答 */
import React from 'react';

export default function article() {
  return (
    <div className="faq-wrap-qs">
      <div className="sx-title">一、如何选择"青山科技奖"申报议题？</div>
      <div className="sx-content">青山科技奖聚焦绿色、低碳、可持续发展。2025年度，奖项主要关注绿色低碳材料、碳捕集及资源化利用、新能源及储能、降碳减污协同控制等，议题释义请参考《申报指南》。</div>
      <div className="sx-content">申报人应评估研究方向与奖项议题的关联，选择不超过2项议题，并在申报书中总结研究工作对所申报议题的贡献和价值。</div>
      <div className="sx-title">二、奖项对申报人学科领域有哪些要求？</div>
      <div className="sx-content">申报人学科领域应为材料科学、环境科学、化学、能源科学、化学工程，或相关的前沿交叉领域。</div>
      <div className="sx-content">前沿交叉领域申报人应确认个人研究方向与上述学科相关，例如人工智能与环境、能源、化工的交叉研究，应以环境、能源、化工为主，交叉选择计算机科学学科。</div>
      <div className="sx-title">三、申报有哪些限制条件？</div>
      <div className="sx-content">申报者年龄不超过45周岁，即1980年1月1日（含）后出生，且在中国内地及港澳地区全职工作，其他条件参见《青山科技奖章程》。</div>
      <div className="sx-title">四、青山科技奖奖项名额如何设置？</div>
      <div className="sx-content">青山科技奖评审综合评估候选人学术水平和创新能力，重点考察在研项目和未来规划的前沿性和应用潜力，及其对绿色、低碳、可持续发展相关议题的贡献及价值。</div>
      <div className="sx-content">2025年，青山科技奖共评选不超过10位获奖人，同等水平下优先支持40岁及以下青年科研工作者、女性科研工作者。</div>
      <div className="sx-title">五、申报有什么时间要求？</div>
      <div className="sx-content">申报人（包括被提名和自主申报）应在2025年9月26日24时前登录青山科技基金官网（https://greentech.meituan.com）完成申报，推荐专家应于2025年9月30日24时前提交推荐信，逾期系统关闭不予受理。</div>
      <div className="sx-title">六、提名、推荐专家每年可推荐几人？</div>
      <div className="sx-content">每位提名、推荐专家每年限提名、推荐一人，否则推荐无效。提名专家完成提名后，不能再担任其他申报人的推荐人。申报人应与提名、推荐专家确认本年度未重复推荐。</div>
      <div className="sx-title">七、对推荐信有什么要求？</div>
      <div className="sx-content">推荐信应专用于青山科技奖申报，内容包含但不限于申报人信息、推荐原因、日期、落款以及推荐专家签章（手签或清晰电子签）等，推荐申报其他项目或奖项的推荐信不能用于申报青山科技奖。</div>
      <div className="sx-title">八、申报渠道有哪些？不同渠道有何区别？</div>
      <div className="sx-content">候选人通过提名和自主申报两个渠道产生。</div>
      <div className="sx-content">提名将由受邀提名专家发起。提名发起后，被提名人将收到通知邮件，邮件内含提名码。被提名人只须在申报系统填写一个提名码。</div>
      <div className="sx-content">自主申报需要申报人联络两位以上正高级职称（教授、研究员、教授级高工等）同行专家推荐。申报人提报材料后，秘书处将向推荐专家邮箱发送通知，每个推荐人邮箱只能提交一次。如申报无法提交，须替换推荐人，或与秘书处联系。</div>
      <div className="sx-content">提名和自主申报两个渠道的评审流程完全相同，候选人可根据实际情况选择任一渠道进行申报。</div>
      <div className="sx-title">九、哪些人可以提名？</div>
      <div className="sx-content">提名人不对外公开。奖项设有提名专家库，邀请国内外相关领域专家参与奖项提名工作。本年度奖项启动申报后，提名专家会收到提名邀请邮件。提名专家可通过邮件链接填写被提名人相关信息。</div>
      <div className="sx-title">十、可以提名/推荐本单位或师生关系的人选吗？</div>
      <div className="sx-content">可以。同单位、师生关系可以进行提名/推荐，申报人进入评审后，提名人、推荐人按照奖项章程规定，在评审过程中回避。</div>
      <div className="sx-title">十一、对申报人、推荐人的国籍是否有要求？</div>
      <div className="sx-content">没有限制，在中国内地或港澳地区全职工作的青年科研工作者都可以申报。</div>
      <div className="sx-title">十二、本年度没有获奖的申报人，明年是否可以申报？</div>
      <div className="sx-content">可以申报，只需要符合申报条件即可。</div>
      <div className="sx-title">十三、奖项如何保证公平性？</div>
      <div className="sx-content">奖项评审实行回避制度，与申请人有利益关联的专家，应当在奖项评审过程中主动回避。应回避的利益关联包括但不限于师生、亲属（直系或旁系）、同课题组、提名、推荐关系等。</div>
      <div className="sx-content">监督委员会将对奖项评审、运营工作进行监督，确保奖项公信力。</div>
      <div className="sx-title">十四、如何保护申报人知识产权？</div>
      <div className="sx-content">参与该奖项工作的全部人员，均依照相关法律法规对涉及奖项申报的全部信息负有高度保密义务。申报系统将为申报、评审材料加盖水印，申报人应注意避免上传涉及机密信息的材料。</div>
      <div className="sx-title">十五、申报人能否查看评审进度，或获得评委反馈？</div>
      <div className="sx-content">申报人材料通过形式审查后，将收到邮件通知。申报人进入终审答辩阶段后，将收到答辩准备通知。除终审答辩现场得到评委反馈外，其他环节将不提供评审信息反馈。</div>
      <div className="sx-title">十六、获奖的申报人应履行哪些义务？</div>
      <div className="sx-content">获奖人受资助期间，应按要求向专家委员会提交年度科研进展报告并不定期出席必要的相关公益和科普活动。</div>
      <div className="sx-title">十七、如何了解更多关于奖项的信息？</div>
      <div className="sx-content">可登录青山科技基金官网（https://greentech.meituan.com/），或关注微信公众号"美团青山计划"，了解申报指南和最新资讯。</div>
      <div className="sx-title text-r">青山科技奖秘书处</div>
      <div className="sx-title text-r">2025年7月</div>
    </div>
  );
}
